import { render, staticRenderFns } from "./AnimatedButton.vue?vue&type=template&id=4725bdde&scoped=true&"
import script from "./AnimatedButton.vue?vue&type=script&lang=ts&"
export * from "./AnimatedButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725bdde",
  null
  
)

export default component.exports